<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11.870000000000001,9.17C11.870000000000001,9.17,11.879999999999999,9.17,11.870000000000001,9.17C11.870000000000001,9.17,8.370000000000001,5.17,8.370000000000001,5.17C8.370000000000001,5.17,8.370000000000001,5.17,8.370000000000001,5.17C8.280000000000001,5.07,8.15,5,8,5C7.85,5,7.720000000000001,5.07,7.63,5.17C7.63,5.17,7.63,5.17,7.63,5.17C7.63,5.17,4.13,9.17,4.13,9.17C4.13,9.17,4.13,9.17,4.13,9.17C4.05,9.26,4,9.370000000000001,4,9.5C4,9.780000000000001,4.22,10,4.5,10C4.5,10,11.5,10,11.5,10C11.780000000000001,10,12,9.780000000000001,12,9.5C12,9.370000000000001,11.95,9.26,11.870000000000001,9.17C11.870000000000001,9.17,11.870000000000001,9.17,11.870000000000001,9.17Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'CaretUp',
} as DefineComponent
</script>
